import React from "react";
import styled from "styled-components";

function FeatherIcon({ icon, color, size, weight }) {
  return <Icon $color={color} $size={size} $weight={weight} className={`feather-icon icon-${icon}`}></Icon>;
}

export default FeatherIcon;

FeatherIcon.defaultProps = {
  size: 16,
  weight: 100,
};

const Icon = styled.i`
  font-size: ${({ $size }) => $size}px;
  font-weight: ${({ $weight }) => $weight};
  ${({ $color }) => ($color ? `color: ${$color};` : null)};
`;
